import { render, staticRenderFns } from "./SetColorGrid.vue?vue&type=template&id=fc322fac&scoped=true"
import script from "./SetColorGrid.vue?vue&type=script&lang=js"
export * from "./SetColorGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc322fac",
  null
  
)

export default component.exports